import React from 'react';
import { Icon } from './Icon.js';
export const IconBallotCircleFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m11.25,4h-5c-.414,0-.75-.336-.75-.75s.336-.75.75-.75h5c.414,0,.75.336.75.75s-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "2", cy: "3", r: "2", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "2", cy: "9", r: "2", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m11.25,9.5h-5c-.414,0-.75-.336-.75-.75s.336-.75.75-.75h5c.414,0,.75.336.75.75s-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconBallotCircleFill12.js.map